const state = {
  dataListData: []
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/data-edit/state.js